import { getValue } from '@model/utils/getters';
import { isImmutable, Map } from 'immutable';
import { NonImmutableValue } from '../../exceptions/NonImmutableValue';
import { separate } from '../../strings';

/**
 * Check if state is immutable, else throw an error
 * @param state
 */
export const immutableCheck = (state: any): void => {
    if (!isImmutable(state)) {
        throw new NonImmutableValue();
    }
};

export const stateSetter =
    (stateProp: string | null = null, payloadProp: string | null = null, payload$: any = undefined) =>
    (state: any, { payload }: any): any => {
        const value = getValue(typeof payload$ !== 'undefined' ? payload$ : payload, payloadProp);

        immutableCheck(state);

        if (!stateProp) {
            return state.merge(isImmutable(value) ? value : Map(value));
        }

        return state.setIn(separate(stateProp, '.'), value);
    };

export const stateToggle =
    (stateProp: string, onValue: any = true, offValue: any = false) =>
    (state: any): any => {
        immutableCheck(state);

        return state.setIn(
            separate(stateProp, '.'),
            state.getIn(separate(stateProp, '.')) === onValue ? offValue : onValue,
        );
    };
